module.exports = __webpack_public_path__ + "img/footer_m.0fb531f8.png";